/* v8 ignore start - style-only / SonarQube */ /* NOSONAR */
import { css } from '@lastbrand/web-ui-styled-system/css'

/*
 * DS presentation for the wishlist share section — mirrors the legacy
 * `wishlist-share-section.module.scss` layout (inline share affordance with an
 * absolutely-positioned confirmation toast). Values in px comments refer to the
 * legacy sheet at its 10px root.
 */

/* eslint-disable i18next/no-literal-string -- Panda CSS literal values (spacing tokens, positions); not user-facing copy */

export const shareWrapperCss = css.raw({
  display: { base: 'flex', lg: 'inline-flex' },
  position: { base: 'initial', lg: 'relative' },
  w: { base: 'full', lg: 'auto' },
  justifyContent: { base: 'center', lg: 'flex-start' },
  mt: { base: 'space-10', lg: '0' },
})

export const shareMsgWrapperCss = css.raw({
  position: 'relative',
})

// The error toast escapes the wrapper on mobile so it can center over the full viewport width.
export const shareMsgWrapperErrorCss = css.raw({
  position: { base: 'initial', lg: 'relative' },
})

export const shareMsgCss = css.raw({
  position: 'absolute',
  background: 'black',
  color: 'white',
  borderRadius: '5px',
  fontWeight: 400,
  whiteSpace: 'nowrap',
  transition: 'background-color 1s ease-out, opacity 1s ease-out, z-index 1s ease-out',
  overflow: 'hidden',
  py: 'space-10',
  px: 'space-20',
  opacity: 0,
  zIndex: -1,
  right: 'auto',
  // Mirrors the legacy toast offset (-0.5rem at the legacy 10px root).
  bottom: '-5px',
  left: 'space-16',
})

export const shareMsgShownCss = css.raw({
  opacity: 1,
  zIndex: 1000,
})

export const shareMsgErrorMobileCss = css.raw({
  transform: { base: 'translateX(-50%)', lg: 'none' },
  left: { base: '50%', lg: 'space-16' },
  bottom: { base: 'space-20', lg: '-5px' },
})

// Compact variant (app-install banner present): the share affordance shrinks to a small inline
// control. Mirrors the legacy `.wishlistShareWrapperCompact` (mobile-only fit-content / no top gap).
export const shareWrapperCompactCss = css.raw({
  w: { base: 'fit-content' },
  mt: { base: '0' },
})

// Applied to the share `TextLink`. Non-compact keeps the legacy uppercase treatment; compact matches the
// DS 2.0 account-heading share affordance (Figma 5013):
//   mweb  (5013:45017) — label then trailing icon, black label, body-14, 6px gap, 20px icon.
//   dweb  (5013:45300) — icon FIRST then label, `gray` (#606060) label, body-14, 4px gap, 16px icon.
// The icon side is the only thing that flips, so the DOM keeps one trailing icon and desktop reverses
// the row visually. That keeps a single icon node and leaves the reading order as "Share" (the icon is
// aria-hidden either way).
export const shareLinkUppercaseCss = css.raw({
  textTransform: 'uppercase',
})

export const shareLinkCompactCss = css.raw({
  textTransform: 'none',
  color: { base: 'black', lg: 'gray' },
  flexDirection: { base: 'row', lg: 'row-reverse' },
  gap: { base: 'space-6', lg: 'space-4' },
  // Figma puts no padding on either share row; the 4px offset from the title comes from the parent
  // stack's gap, so drop the recipe's default paddingY at both breakpoints.
  paddingBlock: '0',
  // body-14 at both breakpoints. This matches the TextLink recipe default, but stays explicit so a
  // recipe change can't silently move the wishlist heading off-spec.
  textStyle: 'body-14',
  // The DS icon defaults to 1em; pin an explicit size (20px mweb / 16px desktop).
  '& svg': {
    width: { base: '20px', lg: '16px' },
    height: { base: '20px', lg: '16px' },
  },
  // Figma specifies only the resting state. Desktop rests at `gray`, which is also the recipe's hover
  // colour, so hover would be a no-op; darken to `black` there instead and leave mweb on the default.
  _hover: {
    color: { base: 'gray', lg: 'black' },
  },
})
/* eslint-enable i18next/no-literal-string */
/* v8 ignore stop */
